import { useRouter } from './useRouter';
/**
 * Возвращает обьект со списком параметров пути
 * @example  /path/1/2  для пути /path/:param1/:param2 вернет {param1: 1, param2: 2}
 *
 * ```typescript
 * import React from "react";
 * import { useParams } from "@okapi/router-react";
 *
 * function Topic() {
 *  const params = useParams();
 *  return <h3>Requested topic ID: {params.topicId}</h3>;
 * }
 * ```
 */
export function useParams() {
    const router = useRouter();
    return router.getParams();
}
